import React from 'react';
import { Link } from 'react-router-dom';

const CartPage: React.FC = () => (
  <div style={{ textAlign: 'center', padding: '4rem' }}>
    <h2 style={{ color: '#303030', marginBottom: '1rem' }}>Cart feature removed</h2>
    <p style={{ marginBottom: '1rem' }}>The shopping cart has been removed from this application.</p>
    <Link to="/products" style={{
      backgroundColor: '#1269cc',
      color: '#ffffff',
      border: 'none',
      padding: '1rem 2rem',
      borderRadius: '8px',
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block'
    }}>
      Continue Shopping
    </Link>
  </div>
);

export default CartPage;